<div class="row">
  <app-cybersocxmenu></app-cybersocxmenu>
</div>
<div class="row">
  <app-incidentform
    (searchEmitter)="search()"
    handlePdfExport="false"
    handleAdvSearch="true"
    #incidentForm
  >
  </app-incidentform>
</div>
<div class="row">
  <div class="col-lg-6 col-sm-12 position-relative">
    <app-pie
      class="card"
      [data]="grouped4AIncidents"
      [drilldownSeries]="grouped4AIncidentsDrilldown"
      title="Incidents by {{ selected4AGroupBy }}"
      innerSize="0"
      suffix=""
    ></app-pie>
    <select
      class="form-select form-control"
      name="groupBy4A"
      aria-describedby="groupBy4A"
      [(ngModel)]="selected4AGroupBy"
      id="groupBy"
      (change)="onSelectGroupBy4A($event.target.value)"
    >
      <option *ngFor="let option of groupBy4AOptions" [value]="option.value">
        {{ option.translateKey | translate }}
      </option>
    </select>
  </div>

  <div class="col-lg-6 col-sm-12 position-relative">
    <app-pie
      class="card"
      [data]="grouped3WIncidents"
      [drilldownSeries]="grouped3WIncidentsDrilldown"
      title="Incidents by {{ selected3WGroupBy }}"
      innerSize="0"
      suffix=""
    ></app-pie>
    <select
      class="form-select form-control"
      name="groupBy3W"
      aria-describedby="groupBy3W"
      [(ngModel)]="selected3WGroupBy"
      id="groupBy"
      (change)="onSelectGroupBy3W($event.target.value)"
    >
      <option *ngFor="let option of groupBy3WOptions" [value]="option.value">
        {{ option.translateKey | translate }}
      </option>
    </select>
  </div>

  <div class="col-sm-12 mt-3">
    <app-sankey class="card" [data]="sankeySeries" title=""> </app-sankey>
  </div>
</div>
